/**
 * AR Wall View - "View on Your Wall" feature for canvas & poster products
 * Dynamically builds a 3D framed artwork using three.js,
 * exports to USDZ (iOS) or GLB (Android), and launches native AR.
 */

(function () {
  'use strict';

  /* ── AYARLAR: ÇERÇEVE ÖLÇÜLERİNİ BURADAN DEĞİŞTİREBİLİRSİN ───────── */
  var INCH_TO_M = 0.0254;

  // Canvas frame dimensions
  var CANVAS_FRAME_WIDTH_M = 0.5 * INCH_TO_M;
  var CANVAS_FRAME_DEPTH_M = 1.5 * INCH_TO_M;
  var CANVAS_FRAME_GAP_M   = 0.25 * INCH_TO_M;

  // Poster frame dimensions
  var POSTER_FRAME_WIDTH_M = 0.35 * INCH_TO_M;
  var POSTER_FRAME_DEPTH_M = 0.35 * INCH_TO_M;
  var POSTER_FRAME_GAP_M   = 0;

  var THREE_CDN = 'https://esm.sh/three@0.170.0';

  /* ── Platform Detection ─────────────────────────────────── */
  function isIOS() {
    return /iPhone|iPad|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }
  function isAndroid() { return /Android/.test(navigator.userAgent); }
  function isMobile() {
    if (isIOS() || isAndroid()) return true;
    // Fallback: touch support + small screen
    return ('ontouchstart' in window || navigator.maxTouchPoints > 0) && window.innerWidth <= 1024;
  }

  /* ── Read product data from Liquid-injected JSON ────────── */
  function getProductData() {
    var el = document.getElementById('arProductData');
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch (e) { return null; }
  }

  function getCurrentVariantId() {
    var input = document.querySelector('input[name="id"]');
    if (input) return parseInt(input.value, 10);
    var data = getProductData();
    return data ? data.currentVariantId : null;
  }

  function getSelectedSize() {
    var data = getProductData();
    if (!data) return null;

    var variantId = getCurrentVariantId();
    var variant = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === variantId) {
        variant = data.variants[i];
        break;
      }
    }
    if (!variant) variant = data.variants[0];

    var sizeOptionPos = -1;
    for (var j = 0; j < data.options.length; j++) {
      var optName = data.options[j].name.toLowerCase();
      if (optName === 'size' || optName.indexOf('size') !== -1) {
        sizeOptionPos = data.options[j].position;
        break;
      }
    }

    var sizeValue = null;
    if (sizeOptionPos > 0 && variant) {
      sizeValue = variant['option' + sizeOptionPos];
    }

    if (!sizeValue && variant) {
      for (var k = 1; k <= 3; k++) {
        var optVal = variant['option' + k];
        if (optVal && parseSizeValue(optVal)) {
          sizeValue = optVal;
          break;
        }
      }
    }
    return sizeValue ? parseSizeValue(sizeValue) : null;
  }

  function parseSizeValue(value) {
    if (!value) return null;
    var lower = value.toLowerCase();

    // Handle named paper sizes (A5, A4, A3, etc.)
    if (lower.indexOf('a5') !== -1) return { widthIn: 5.8, heightIn: 8.3 };
    if (lower.indexOf('a4') !== -1) return { widthIn: 8.3, heightIn: 11.7 };
    if (lower.indexOf('a3') !== -1) return { widthIn: 11.7, heightIn: 16.5 };
    if (lower.indexOf('a2') !== -1) return { widthIn: 16.5, heightIn: 23.4 };
    if (lower.indexOf('a1') !== -1) return { widthIn: 23.4, heightIn: 33.1 };

    var cleaned = value;
    if (cleaned.indexOf('/') !== -1) cleaned = cleaned.split('/')[0];

    // Detect if value is in cm (check the split part, not the full string)
    var isCm = cleaned.toLowerCase().indexOf('cm') !== -1;

    // Replace × (multiplication sign) and whitespace variants with letter x
    cleaned = cleaned.replace(/\u00d7/g, 'x').replace(/[^0-9.x]/gi, '');
    var match = cleaned.match(/(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)/i);
    if (!match) return null;
    var w = parseFloat(match[1]);
    var h = parseFloat(match[2]);
    if (isNaN(w) || isNaN(h) || w < 1 || h < 1) return null;

    // Convert cm to inches if needed
    if (isCm) {
      w = w / 2.54;
      h = h / 2.54;
    }

    return { widthIn: w, heightIn: h };
  }

  function getSelectedFrame() {
    var data = getProductData();
    if (!data) return 'black';

    var variantId = getCurrentVariantId();
    var variant = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === variantId) {
        variant = data.variants[i];
        break;
      }
    }
    if (!variant) return 'black';

    for (var j = 0; j < data.options.length; j++) {
      var optName = data.options[j].name.toLowerCase();
      if (optName.indexOf('frame') !== -1 || optName.indexOf('style') !== -1) {
        var pos = data.options[j].position;
        var val = variant['option' + pos];
        return val ? val.trim().toLowerCase() : 'black';
      }
    }
    return 'black';
  }

  function getFrameTextures() {
    var el = document.getElementById('arFrameTextureData');
    if (!el) return {};
    try { return JSON.parse(el.textContent); }
    catch (e) { return {}; }
  }

  var _threeCache = null;
  async function loadThree() {
    if (_threeCache) return _threeCache;
    var results = await Promise.all([
      import(/* webpackIgnore: true */ THREE_CDN),
      import(/* webpackIgnore: true */ THREE_CDN + '/addons/exporters/USDZExporter.js'),
      import(/* webpackIgnore: true */ THREE_CDN + '/addons/exporters/GLTFExporter.js')
    ]);
    _threeCache = {
      THREE: results[0],
      USDZExporter: results[1].USDZExporter,
      GLTFExporter: results[2].GLTFExporter
    };
    return _threeCache;
  }

  function loadTexture(THREE, url) {
    return fetch(url, { mode: 'cors', credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('Fetch failed: ' + res.status);
        return res.blob();
      })
      .then(function (blob) { return createImageBitmap(blob); })
      .then(function (bitmap) {
        var canvas = document.createElement('canvas');
        canvas.width = bitmap.width;
        canvas.height = bitmap.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(bitmap, 0, 0);
        var tex = new THREE.CanvasTexture(canvas);
        tex.colorSpace = THREE.SRGBColorSpace;
        tex.needsUpdate = true;
        return tex;
      });
  }

  /* ── Poster Border Cropping ───────────────────────────────
     Poster images have white background + thin black border.
     This crops to the artwork inside. ──────────────────────── */
  function cropPosterBorder(THREE, tex) {
    var canvas = tex.image;
    var w = canvas.width, h = canvas.height;
    var ctx = canvas.getContext('2d');
    var imgData = ctx.getImageData(0, 0, w, h);
    var px = imgData.data;

    // Check if a pixel is "white-ish" (background)
    function isWhite(x, y) {
      var i = (y * w + x) * 4;
      return px[i] > 230 && px[i+1] > 230 && px[i+2] > 230;
    }
    // Check if a pixel is "dark" (border line)
    function isDark(x, y) {
      var i = (y * w + x) * 4;
      return px[i] < 80 && px[i+1] < 80 && px[i+2] < 80;
    }

    // Scan inward from each edge to find where artwork starts
    var cx = Math.floor(w / 2), cy = Math.floor(h / 2);

    // Scan from left
    var left = 0;
    for (var x = 0; x < w * 0.3; x++) {
      if (!isWhite(x, cy) && !isDark(x, cy)) { left = x; break; }
      if (isDark(x, cy)) { left = x + 1; break; }
    }

    // Scan from right
    var right = w - 1;
    for (var x = w - 1; x > w * 0.7; x--) {
      if (!isWhite(x, cy) && !isDark(x, cy)) { right = x; break; }
      if (isDark(x, cy)) { right = x - 1; break; }
    }

    // Scan from top
    var top = 0;
    for (var y = 0; y < h * 0.3; y++) {
      if (!isWhite(cx, y) && !isDark(cx, y)) { top = y; break; }
      if (isDark(cx, y)) { top = y + 1; break; }
    }

    // Scan from bottom
    var bottom = h - 1;
    for (var y = h - 1; y > h * 0.7; y--) {
      if (!isWhite(cx, y) && !isDark(cx, y)) { bottom = y; break; }
      if (isDark(cx, y)) { bottom = y - 1; break; }
    }

    // Add a small inward margin to ensure no border remnants
    var margin = 2;
    left = Math.min(left + margin, right);
    top = Math.min(top + margin, bottom);
    right = Math.max(right - margin, left);
    bottom = Math.max(bottom - margin, top);

    var cropW = right - left + 1;
    var cropH = bottom - top + 1;

    console.log('[AR] Poster crop: left=' + left + ' top=' + top + ' w=' + cropW + ' h=' + cropH + ' (original ' + w + 'x' + h + ')');

    // Create cropped canvas
    var cropped = document.createElement('canvas');
    cropped.width = cropW;
    cropped.height = cropH;
    var cCtx = cropped.getContext('2d');
    cCtx.drawImage(canvas, left, top, cropW, cropH, 0, 0, cropW, cropH);

    var croppedTex = new THREE.CanvasTexture(cropped);
    croppedTex.colorSpace = THREE.SRGBColorSpace;
    croppedTex.needsUpdate = true;
    return croppedTex;
  }

  /* ── Build 3D Scene ─────────────────────────────────────── */
  async function buildScene(THREE, artworkUrl, widthM, heightM, frameTextureUrl, productType) {
    var scene = new THREE.Scene();
    var isPoster = (productType === 'poster');

    var fw = isPoster ? POSTER_FRAME_WIDTH_M : CANVAS_FRAME_WIDTH_M;
    var fd = isPoster ? POSTER_FRAME_DEPTH_M : CANVAS_FRAME_DEPTH_M;
    var fg = isPoster ? POSTER_FRAME_GAP_M : CANVAS_FRAME_GAP_M;
    var frameZCenter = fd / 2;

    var artworkTex = await loadTexture(THREE, artworkUrl);

    // Crop poster borders (white background + black line)
    if (isPoster) {
      artworkTex = cropPosterBorder(THREE, artworkTex);
    }

    // Aynalı Kenarları Oluşturan Yardımcı Fonksiyon (Aynı Kaldı)
    function createMirroredCanvas(w, h, d) {
      var group = new THREE.Group();
      var wrapF = 0.08; 

      var mat = new THREE.MeshStandardMaterial({
        map: artworkTex,
        side: THREE.FrontSide,
        roughness: 1.0,
        metalness: 0.0
      });

      function remapUVs(geo, uMin, uMax, vMin, vMax) {
        var uvs = geo.attributes.uv.array;
        for (var i = 0; i < uvs.length; i += 2) {
          var u = uvs[i]; 
          var v = uvs[i + 1];
          uvs[i] = uMin + u * (uMax - uMin);
          uvs[i + 1] = vMin + v * (vMax - vMin);
        }
        geo.attributes.uv.needsUpdate = true;
        return geo;
      }

      var front = new THREE.Mesh(new THREE.PlaneGeometry(w, h), mat);
      front.position.set(0, 0, d);
      group.add(front);

      var rightGeo = remapUVs(new THREE.PlaneGeometry(d, h), 1.0, 1.0 - wrapF, 0.0, 1.0);
      var right = new THREE.Mesh(rightGeo, mat);
      right.rotation.y = Math.PI / 2; 
      right.position.set(w / 2, 0, d / 2);
      group.add(right);

      var leftGeo = remapUVs(new THREE.PlaneGeometry(d, h), wrapF, 0.0, 0.0, 1.0);
      var left = new THREE.Mesh(leftGeo, mat);
      left.rotation.y = -Math.PI / 2; 
      left.position.set(-w / 2, 0, d / 2);
      group.add(left);

      var topGeo = remapUVs(new THREE.PlaneGeometry(w, d), 0.0, 1.0, 1.0, 1.0 - wrapF);
      var top = new THREE.Mesh(topGeo, mat);
      top.rotation.x = -Math.PI / 2; 
      top.position.set(0, h / 2, d / 2);
      group.add(top);

      var bottomGeo = remapUVs(new THREE.PlaneGeometry(w, d), 0.0, 1.0, wrapF, 0.0);
      var bottom = new THREE.Mesh(bottomGeo, mat);
      bottom.rotation.x = Math.PI / 2; 
      bottom.position.set(0, -h / 2, d / 2);
      group.add(bottom);

      var backMat = new THREE.MeshStandardMaterial({ color: 0x111111, roughness: 1.0, metalness: 0.0 });
      var back = new THREE.Mesh(new THREE.PlaneGeometry(w, h), backMat);
      back.rotation.y = Math.PI; 
      back.position.set(0, 0, 0);
      group.add(back);

      return group;
    }

    // YENİ: 45 Derece Kesimli (Mitered) Çerçeve Geometrisi Oluşturan Fonksiyon
    function createMiteredBox(innerWidth, frameWidth, frameDepth) {
      var outerWidth = innerWidth + 2 * frameWidth;
      var geo = new THREE.BoxGeometry(outerWidth, frameWidth, frameDepth);
      var pos = geo.attributes.position;

      // Default BoxGeometry UVs map the full texture (0→1) across each face.
      // This stretches the grain along the frame's length — no tiling needed.

      // Mitered cut: narrow inner edge vertices
      for (var i = 0; i < pos.count; i++) {
        var x = pos.getX(i);
        var y = pos.getY(i);

        if (y < -0.0001) {
          if (x > 0.0001) pos.setX(i, x - frameWidth);
          else if (x < -0.0001) pos.setX(i, x + frameWidth);
        }
      }
      geo.computeVertexNormals();
      return geo;
    }

    // ── Çerçeve Mantığı ──
    var hasFrame = frameTextureUrl && frameTextureUrl.length > 0;
    if (hasFrame) {
      var frameMat;
      try {
        var frameTex = await loadTexture(THREE, frameTextureUrl);
        frameTex.wrapS = THREE.ClampToEdgeWrapping;
        frameTex.wrapT = THREE.ClampToEdgeWrapping;
        frameMat = new THREE.MeshStandardMaterial({ map: frameTex, roughness: 1.0, metalness: 0.0 });
      } catch (e) {
        frameMat = new THREE.MeshStandardMaterial({ color: 0x2a2a2a, roughness: 1.0, metalness: 0.0 });
      }

      var innerW = widthM + (2 * fg);
      var innerH = heightM + (2 * fg);

      // Üst Parça
      var topGeo = createMiteredBox(innerW, fw, fd);
      var topPiece = new THREE.Mesh(topGeo, frameMat);
      topPiece.position.set(0, (innerH / 2) + (fw / 2), frameZCenter);
      scene.add(topPiece);

      // Alt Parça (180 derece çevrilmiş)
      var bottomGeo = createMiteredBox(innerW, fw, fd);
      var bottomPiece = new THREE.Mesh(bottomGeo, frameMat);
      bottomPiece.position.set(0, -((innerH / 2) + (fw / 2)), frameZCenter);
      bottomPiece.rotation.z = Math.PI;
      scene.add(bottomPiece);

      // Sol Parça (90 derece çevrilmiş)
      var leftGeo = createMiteredBox(innerH, fw, fd);
      var leftPiece = new THREE.Mesh(leftGeo, frameMat);
      leftPiece.position.set(-((innerW / 2) + (fw / 2)), 0, frameZCenter);
      leftPiece.rotation.z = Math.PI / 2;
      scene.add(leftPiece);

      // Sağ Parça (-90 derece çevrilmiş)
      var rightGeo = createMiteredBox(innerH, fw, fd);
      var rightPiece = new THREE.Mesh(rightGeo, frameMat);
      rightPiece.position.set(((innerW / 2) + (fw / 2)), 0, frameZCenter);
      rightPiece.rotation.z = -Math.PI / 2;
      scene.add(rightPiece);

      // Arka Siyah Panel
      var backPanel = new THREE.Mesh(
        new THREE.PlaneGeometry(innerW + 2 * fw, innerH + 2 * fw),
        new THREE.MeshStandardMaterial({ color: 0x151515, roughness: 1.0, metalness: 0.0 })
      );
      backPanel.position.set(0, 0, 0.001);
      scene.add(backPanel);

      if (isPoster) {
        // Poster: flat artwork plane with slight depth (paper + mat)
        var posterDepth = 0.003; // ~3mm total (mat + paper)
        var artMat = new THREE.MeshStandardMaterial({ map: artworkTex, roughness: 1.0, metalness: 0.0 });
        var artPlane = new THREE.Mesh(new THREE.PlaneGeometry(widthM, heightM), artMat);
        artPlane.position.set(0, 0, posterDepth);
        scene.add(artPlane);
      } else {
        // Canvas: floating frame with mirrored canvas edges
        var canvasDepth = fd - 0.005;
        var canvasGroup = createMirroredCanvas(widthM, heightM, canvasDepth);
        scene.add(canvasGroup);
      }

    } else {
      if (isPoster) {
        // Poster with no frame: just a flat print
        var artMat = new THREE.MeshStandardMaterial({ map: artworkTex, roughness: 1.0, metalness: 0.0 });
        var artPlane = new THREE.Mesh(new THREE.PlaneGeometry(widthM, heightM), artMat);
        artPlane.position.set(0, 0, 0.002);
        scene.add(artPlane);
      } else {
        // Canvas stretched (no frame)
        var canvasDepth = 0.038;
        var canvasGroup = createMirroredCanvas(widthM, heightM, canvasDepth);
        scene.add(canvasGroup);
      }
    }

    // ── Aydınlatma ──
    // Use only ambient light to avoid directional light adding color tint
    scene.add(new THREE.AmbientLight(0xffffff, 1.0));

    scene.updateMatrixWorld(true);

    return scene;
  }

  /* ── Export USDZ (iOS) ──────────────────────────────────── */
  async function exportUSDZ(USDZExp, scene) {
    var exporter = new USDZExp();
    return await exporter.parseAsync(scene);
  }

  /* ── Export GLB (Android) ───────────────────────────────── */
  function exportGLB(GLTFExp, scene) {
    return new Promise(function (resolve, reject) {
      new GLTFExp().parse(scene,
        function (r) { resolve(r); },
        function (e) { reject(e); },
        { binary: true }
      );
    });
  }

  /* ── Launch AR (iOS) ────────────────────────────────────── */
  function launchARiOS(usdzBuffer) {
    var blob = new Blob([usdzBuffer], { type: 'model/vnd.usdz+zip' });
    var url = URL.createObjectURL(blob);
    var anchor = document.getElementById('arQuickLookAnchor');
    if (anchor) {
      anchor.href = url + '#allowsContentScaling=0';
      anchor.click();
    } else {
      var a = document.createElement('a');
      a.rel = 'ar';
      a.href = url + '#allowsContentScaling=0';
      var img = document.createElement('img');
      img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
      a.appendChild(img);
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { document.body.removeChild(a); }, 1000);
    }
    setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
  }

  /* ── Launch AR (Android) via <model-viewer> WebXR ─────── */
  var _modelViewerLoaded = false;
  function ensureModelViewer() {
    if (_modelViewerLoaded) return Promise.resolve();
    _modelViewerLoaded = true;
    return new Promise(function (resolve) {
      var script = document.createElement('script');
      script.type = 'module';
      script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0/model-viewer.min.js';
      script.onload = resolve;
      script.onerror = function () { _modelViewerLoaded = false; resolve(); };
      document.head.appendChild(script);
    });
  }

  async function launchARAndroid(glbBuffer) {
    var blob = new Blob([glbBuffer], { type: 'model/gltf-binary' });
    var blobUrl = URL.createObjectURL(blob);

    await ensureModelViewer();

    // Remove any previous model-viewer AR container
    var existing = document.getElementById('arModelViewerWrap');
    if (existing) existing.remove();

    // Create a fullscreen overlay with <model-viewer>
    var wrap = document.createElement('div');
    wrap.id = 'arModelViewerWrap';
    wrap.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;z-index:999999;background:#000;';

    var mv = document.createElement('model-viewer');
    mv.setAttribute('src', blobUrl);
    mv.setAttribute('ar', '');
    mv.setAttribute('ar-modes', 'webxr scene-viewer');
    mv.setAttribute('ar-placement', 'wall');
    mv.setAttribute('ar-scale', 'fixed');
    mv.setAttribute('camera-controls', '');
    mv.setAttribute('shadow-intensity', '1');
    mv.setAttribute('alt', 'Wall Art AR Preview');
    mv.style.cssText = 'width:100%;height:100%;';

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.textContent = '\u2715';
    closeBtn.style.cssText = 'position:absolute;top:16px;right:16px;z-index:10;background:rgba(0,0,0,0.6);color:#fff;border:none;border-radius:50%;width:40px;height:40px;font-size:20px;cursor:pointer;';
    closeBtn.addEventListener('click', function () {
      wrap.remove();
      URL.revokeObjectURL(blobUrl);
    });

    // AR button slot
    var arBtn = document.createElement('button');
    arBtn.setAttribute('slot', 'ar-button');
    arBtn.textContent = 'Place on Wall';
    arBtn.style.cssText = 'position:absolute;bottom:24px;left:50%;transform:translateX(-50%);background:#2d4a3e;color:#fff;border:none;border-radius:8px;padding:14px 28px;font-size:16px;font-weight:600;cursor:pointer;';
    mv.appendChild(arBtn);

    wrap.appendChild(closeBtn);
    wrap.appendChild(mv);
    document.body.appendChild(wrap);

    // Auto-activate AR after model loads
    mv.addEventListener('load', function () {
      setTimeout(function () {
        if (mv.canActivateAR) {
          mv.activateAR();
        }
      }, 500);
    });

    // Clean up when AR session ends
    mv.addEventListener('ar-status', function (e) {
      if (e.detail.status === 'failed' || e.detail.status === 'not-presenting') {
        // Keep the 3D preview open so user can retry or close
      }
    });
  }

  /* ── UI Helpers ─────────────────────────────────────────── */
  function setLoading(btn, loading) {
    btn.classList.toggle('ar-wall-btn--loading', loading);
    btn.disabled = loading;
    btn.querySelector('.ar-wall-btn__label').textContent = loading ? 'Loading AR...' : 'View in Room';
  }

  function showARError(msg) {
    var t = document.createElement('div');
    t.className = 'ar-wall-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('ar-wall-toast--visible'); });
    setTimeout(function () {
      t.classList.remove('ar-wall-toast--visible');
      setTimeout(function () { t.remove(); }, 300);
    }, 3000);
  }

  /* ── Main AR Launch ─────────────────────────────────────── */
  async function handleARLaunch(btn) {
    var productType = btn.dataset.productType || 'canvas';
    var size = getSelectedSize();

    if (!size) {
      alert('Could not read product size.');
      return;
    }

    var mainUrl = btn.dataset.artworkUrl;
    var finalArtworkUrl = mainUrl;
    var finalWidthIn, finalHeightIn;

    if (productType === 'poster') {
      // Poster: sizes list short side first (e.g. 30×40 = 30 short, 40 long)
      // Orientation comes from product tags via data attribute
      var orientation = btn.dataset.orientation || 'landscape';
      var shortSide = Math.min(size.widthIn, size.heightIn);
      var longSide = Math.max(size.widthIn, size.heightIn);
      if (orientation === 'portrait') {
        finalWidthIn = shortSide;
        finalHeightIn = longSide;
      } else {
        finalWidthIn = longSide;
        finalHeightIn = shortSide;
      }
      console.log('[AR] Poster size: ' + finalWidthIn.toFixed(1) + '" x ' + finalHeightIn.toFixed(1) + '" (' + orientation + ')');
    } else {
      // Canvas: use image aspect ratio to determine orientation
      var dim1 = size.widthIn;
      var dim2 = size.heightIn;
      var minDim = Math.min(dim1, dim2);
      var maxDim = Math.max(dim1, dim2);
      var targetAspect = maxDim / minDim;

      var mainRatio = parseFloat(btn.dataset.artworkRatio) || 1;
      var mainAspect = mainRatio >= 1 ? mainRatio : (1 / mainRatio);

      var altUrl = btn.dataset.artworkAltUrl;
      var altRatio = parseFloat(btn.dataset.artworkAltRatio);
      var altAspect = altRatio >= 1 ? altRatio : (1 / altRatio);

      var finalRatio = mainRatio;

      if (altUrl && !isNaN(altRatio)) {
        var diffMain = Math.abs(mainAspect - targetAspect);
        var diffAlt = Math.abs(altAspect - targetAspect);

        if (diffAlt < diffMain) {
          finalArtworkUrl = altUrl;
          finalRatio = altRatio;
          console.log('[AR] Alternative image selected. Ratio:', finalRatio);
        } else {
          console.log('[AR] Main image selected. Ratio:', finalRatio);
        }
      }

      if (finalRatio >= 1) {
        finalWidthIn = maxDim;
        finalHeightIn = minDim;
      } else {
        finalWidthIn = minDim;
        finalHeightIn = maxDim;
      }
      console.log('[AR] Canvas size: ' + finalWidthIn + '" x ' + finalHeightIn + '" (Oriented to match image)');
    }

    // Convert inches to meters
    var widthM = finalWidthIn * INCH_TO_M;
    var heightM = finalHeightIn * INCH_TO_M;

    if (!finalArtworkUrl) { showARError('Artwork image not available'); return; }

    var frameName = getSelectedFrame();
    var textures = getFrameTextures();
    var frameTextureUrl = null;
    if (frameName !== 'stretched' && frameName !== 'no frame' && frameName !== 'no-frame') {
      frameTextureUrl = textures[frameName] || null;
    }

    setLoading(btn, true);

    try {
      var loaded = await loadThree();
      var THREE = loaded.THREE;
      
      var arScene = await buildScene(THREE, finalArtworkUrl, widthM, heightM, frameTextureUrl, productType);

      if (isIOS()) {
        var usdz = await exportUSDZ(loaded.USDZExporter, arScene);
        launchARiOS(usdz);
      } else if (isAndroid()) {
        var glb = await exportGLB(loaded.GLTFExporter, arScene);
        launchARAndroid(glb);
      }
    } catch (err) {
      console.error('[AR] Error:', err);
      alert('[AR] Error: ' + err.message);
    } finally {
      setLoading(btn, false);
    }
  }

  /* ── AR Info Popup ────────────────────────────────────────── */
  function showARPopup(btn) {
    // Don't show if already visible
    if (document.getElementById('arInfoPopup')) return;

    var overlay = document.createElement('div');
    overlay.id = 'arInfoPopup';
    overlay.className = 'ar-popup-overlay';
    overlay.innerHTML =
      '<div class="ar-popup">' +
        '<div class="ar-popup__icon">' +
          '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M12 3L2 8l10 5 10-5-10-5z"/>' +
            '<path d="M2 8v8l10 5"/><path d="M22 8v8l-10 5"/>' +
            '<path d="M12 13v8"/>' +
          '</svg>' +
        '</div>' +
        '<h3 class="ar-popup__title">View on Your Wall</h3>' +
        '<ul class="ar-popup__list">' +
          '<li>Select your preferred <strong>size</strong> and <strong>frame</strong> before launching AR</li>' +
          '<li>Point your camera at a wall and tap to place the artwork</li>' +
          '<li>This is a preview — actual colors and textures may vary slightly</li>' +
        '</ul>' +
        '<div class="ar-popup__actions">' +
          '<button type="button" class="ar-popup__btn ar-popup__btn--primary" id="arPopupContinue">Continue to AR</button>' +
          '<button type="button" class="ar-popup__btn ar-popup__btn--secondary" id="arPopupCancel">Cancel</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    requestAnimationFrame(function () { overlay.classList.add('ar-popup-overlay--visible'); });

    document.getElementById('arPopupContinue').addEventListener('click', function () {
      closeARPopup(overlay);
      handleARLaunch(btn);
    });

    document.getElementById('arPopupCancel').addEventListener('click', function () {
      closeARPopup(overlay);
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeARPopup(overlay);
    });
  }

  function closeARPopup(overlay) {
    overlay.classList.remove('ar-popup-overlay--visible');
    setTimeout(function () { overlay.remove(); }, 300);
  }

  /* ── Desktop: QR code flow ──────────────────────────────────
     Generate a QR code pointing at the current product URL so
     the customer can scan it with their phone and continue the
     AR flow there. Uses a tiny inline QR generator (no CDN) so
     it works offline and without network roundtrips. ────────── */
  function ensureQrLib() {
    if (window.QRCode) return Promise.resolve(window.QRCode);
    return new Promise(function (resolve) {
      var script = document.createElement('script');
      // qrcode-generator (small, MIT). Falls back to Google Charts PNG if CDN fails.
      script.src = 'https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.min.js';
      script.onload = function () { resolve(window.qrcode); };
      script.onerror = function () { resolve(null); };
      document.head.appendChild(script);
    });
  }

  function buildQrImage(url, size) {
    return ensureQrLib().then(function (qrcode) {
      if (qrcode) {
        try {
          var qr = qrcode(0, 'M');
          qr.addData(url);
          qr.make();
          var cells = qr.getModuleCount();
          var cell = Math.floor(size / cells);
          var px = cell * cells;
          var canvas = document.createElement('canvas');
          canvas.width = canvas.height = px;
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, px, px);
          ctx.fillStyle = '#111';
          for (var r = 0; r < cells; r++) {
            for (var c = 0; c < cells; c++) {
              if (qr.isDark(r, c)) ctx.fillRect(c * cell, r * cell, cell, cell);
            }
          }
          return canvas;
        } catch (e) { /* fall through */ }
      }
      // Fallback: use a public QR renderer (static PNG)
      var img = document.createElement('img');
      img.alt = 'QR code';
      img.width = size; img.height = size;
      img.src = 'https://api.qrserver.com/v1/create-qr-code/?size=' +
                size + 'x' + size + '&margin=0&data=' + encodeURIComponent(url);
      return img;
    });
  }

  function showDesktopQrModal() {
    var existing = document.getElementById('arQrOverlay');
    if (existing) { existing.classList.add('is-active'); return; }

    var overlay = document.createElement('div');
    overlay.id = 'arQrOverlay';
    overlay.className = 'ar-qr-overlay';
    overlay.innerHTML =
      '<div class="ar-qr-modal">' +
        '<button type="button" class="ar-qr-modal__close" aria-label="Close">&times;</button>' +
        '<h3 class="ar-qr-modal__title">View on your wall</h3>' +
        '<p class="ar-qr-modal__subtitle">Scan this code with your phone camera to open AR.</p>' +
        '<div class="ar-qr-modal__qr" data-qr-target></div>' +
        '<p class="ar-qr-modal__hint"><strong>Tip:</strong> pick your size &amp; frame first — the scanned page will use whatever you selected here.</p>' +
        '<button type="button" class="ar-qr-modal__btn" data-qr-copy>Copy link</button>' +
      '</div>';
    document.body.appendChild(overlay);

    var target = overlay.querySelector('[data-qr-target]');
    var url    = window.location.href.split('#')[0];
    buildQrImage(url, 220).then(function (node) {
      target.innerHTML = '';
      if (node) target.appendChild(node);
    });

    overlay.querySelector('.ar-qr-modal__close').addEventListener('click', function () {
      overlay.classList.remove('is-active');
      setTimeout(function () { overlay.remove(); }, 250);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        overlay.classList.remove('is-active');
        setTimeout(function () { overlay.remove(); }, 250);
      }
    });
    var copyBtn = overlay.querySelector('[data-qr-copy]');
    copyBtn.addEventListener('click', function () {
      var original = copyBtn.textContent;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          copyBtn.textContent = 'Link copied';
          setTimeout(function () { copyBtn.textContent = original; }, 1600);
        });
      } else {
        var temp = document.createElement('input');
        temp.value = url;
        document.body.appendChild(temp);
        temp.select();
        try { document.execCommand('copy'); copyBtn.textContent = 'Link copied'; }
        catch (e) { copyBtn.textContent = 'Copy failed'; }
        temp.remove();
        setTimeout(function () { copyBtn.textContent = original; }, 1600);
      }
    });

    requestAnimationFrame(function () { overlay.classList.add('is-active'); });
  }

  /* ── Init & Modal Logic ─────────────────────────────────── */
  function init() {
    var btn = document.getElementById('arWallBtn');
    if (!btn) return;

    // Button is shown on all viewports — mobile launches native AR,
    // desktop opens a QR modal so the user can continue on their phone.
    btn.style.display = 'flex';

    // Move modal to <body> so it escapes any parent transform/stacking context
    var modal = document.getElementById('arWarningModal');
    if (modal && modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    var cancelBtn = document.getElementById('arModalCancel');
    var continueBtn = document.getElementById('arModalContinue');

    // 1. Click behaviour branches by device:
    //    - mobile  → existing quick-tip modal → launch AR
    //    - desktop → QR code modal so the customer can scan & continue
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!isMobile()) {
        showDesktopQrModal();
        return;
      }
      if (modal) {
        modal.classList.add('is-active');
      } else {
        handleARLaunch(btn);
      }
    });

    if (modal) {
      // 2. Close modal on Cancel
      cancelBtn.addEventListener('click', function() {
        modal.classList.remove('is-active');
      });

      // 3. Close modal and launch AR on Continue
      continueBtn.addEventListener('click', function() {
        modal.classList.remove('is-active');
        // Add a tiny delay so the modal closing animation can start smoothly
        setTimeout(function() {
          handleARLaunch(btn);
        }, 100);
      });

      // 4. Optional: Close modal if user clicks outside the white box
      modal.addEventListener('click', function(e) {
        if (e.target === modal) {
          modal.classList.remove('is-active');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();